import { RouteConfig } from 'vue-router';
import InvitationsOverview from '@/views/invitations/InvitationsOverview.vue';
import InviteModal from '@/views/invitations/InviteModal.vue';
import PageModal from '@/components/modals/PageModal.vue';
import InviteResendModal from '@/views/invitations/InviteResendModal.vue';
import PremiumCaseReferralOverview
	from '@/views/premiumpartners/PremiumCaseReferralOverview.vue';
import ReferralsMarkBilledModal from '@/views/premiumpartners/ReferralsMarkBilledModal.vue';
import PremiumPartnersOverview from '@/views/premiumpartners/PremiumPartnersOverview.vue';
import CompanyProfile from '@/views/default/CompanyProfile.vue';
import PremiumLawyerOfficeProfile from '@/views/premiumpartners/PremiumLawyerOfficeProfile.vue';


const routes: Array<RouteConfig> = [
	{
		path: '/premiumpartners/referrals',
		name: 'premiumcasereferrals',
		component: PremiumCaseReferralOverview,
		children: [
			{
				path: '/premiumpartners/set-to-billed',
				name: 'setToBilled',
				component: PageModal,
				props: {
					title: 'Abrechnung bestätigen',
					component: ReferralsMarkBilledModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
		],
	},
	{
		path: '/premiumpartners/lawyers',
		name: 'premiumpartners',
		component: PremiumPartnersOverview,
	},
	{
		path: '/premiumpartners/lawyers/:id',
		name: 'PremiumLawyerOfficeProfile',
		component: PremiumLawyerOfficeProfile,
	},
];

export default routes;
